import React, { memo, VFC } from 'react';
import NearbyPlacesComponent from './components';
import { NearbyPlacesProps } from './types';

const NearbyPlaces: VFC<NearbyPlacesProps> = memo(
  (props: NearbyPlacesProps) => {
    return <NearbyPlacesComponent {...props} />;
  },
);

export default NearbyPlaces;
